import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const globalColorDark = {
    color: {
        action: {
            toggleButton: {
                indicator: {
                    default: tokens.CMP_COLOR_ACTION_TOGGLE_BUTTON_INDICATOR_DEFAULT_DARK
                }
            }
        },
        typography: {
            copy: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_DARK
            },
            headline: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_DEFAULT_DARK,
                order1: tokens.GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_ORDER1_DARK
            },
            display: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_DISPLAY_DEFAULT_DARK
            }
        },
        elevation: {
            level1: tokens.GLOBAL_COLOR_ELEVATION_LEVEL1_DARK,
            level2: tokens.GLOBAL_COLOR_ELEVATION_LEVEL2_DARK,
            level3: tokens.GLOBAL_COLOR_ELEVATION_LEVEL3_DARK,
            level4: tokens.GLOBAL_COLOR_ELEVATION_LEVEL4_DARK
        },
        canvas: {
            default: tokens.GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
            inverted: tokens.GLOBAL_COLOR_CANVAS_INVERTED_DARK
        }
    }
};
//# sourceMappingURL=color.dark.js.map